import * as React from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns'
import { GridFilterCellProps } from '@progress/kendo-react-grid'
import { SelectValue } from 'components/Filter/FilterCell/MultiSelectFilterCell'

interface DropdownFilterCellProps extends GridFilterCellProps {
  defaultItem: string
  data: string[]
}

const hasValue: (value: SelectValue, defaultItem: SelectValue) => boolean = (
  value: SelectValue,
  defaultItem: SelectValue
) => Boolean(value && value !== defaultItem)

export const DropdownFilterCell: React.FC<DropdownFilterCellProps> = ({
  value,
  defaultItem,
  onChange,
  data,
}) => {
  const handleOnChange = (event: DropDownListChangeEvent) => {
    const hasValueResult = hasValue(event.target.value, defaultItem)
    onChange({
      value: hasValueResult ? event.target.value : '',
      operator: hasValueResult ? 'eq' : '',
      syntheticEvent: event.syntheticEvent,
    })
  }

  const onClearButtonClick = (event: React.MouseEvent) => {
    event.preventDefault()
    onChange({
      value: '',
      operator: '',
      syntheticEvent: event,
    })
  }
  return (
    <div className='k-filtercell'>
      <DropDownList
        data={data}
        onChange={handleOnChange}
        value={value || defaultItem}
        defaultItem={defaultItem}
      />
      <Button title='Clear' onClick={onClearButtonClick} icon='filter-clear' />
    </div>
  )
}
